/* tslint:disable */
/* eslint-disable */
export enum LoanPurposeEnum {
  VehiclePurchase = 'VehiclePurchase',
  DebtConsolidation = 'DebtConsolidation',
  HolidayOrTravel = 'HolidayOrTravel',
  Wedding = 'Wedding',
  Funeral = 'Funeral',
  VehicleRepairs = 'VehicleRepairs',
  HomeRenovations = 'HomeRenovations',
  Medical = 'Medical',
  Education = 'Education',
  Furnishings = 'Furnishings',
  Other = 'Other'
}
